import axios from 'axios';

export interface FollowUpTeams {
  pedidoId: string;
  numeroPedido: string;
  cliente: string;
  vendedor: string;
  mensagem: string;
  cirurgia: {
    modalidade: string;
    tipo: string;
    data: string;
    hora: string;
    hospital: string;
    paciente: string;
    medico: string;
    crm: string;
    convenio: string;
    observacoes: string;
  };
}

/**
 * Encaminha pelo proxy do próprio Web Suplen. O Nginx repassa a chamada à
 * função /api/teams-followup já usada pelo app; o JWT segue no servidor e a
 * URL secreta do workflow nunca é exposta no navegador.
 */
export async function notificarFollowUpTeams(dados: FollowUpTeams, token: string) {
  await axios.post('/api/teams-followup', dados, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 15000,
  });
}
